<mat-card>
  <p [innerHtml]="logs.logs"></p>
</mat-card>
